import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Channel } from 'icreate/common/models/channel';
import { OpsUser } from 'icreate/common/models/ops-user';
import { ReposeGroup } from 'icreate/common/models/repose-group';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReposeGroupService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAll(vesselId: string): Promise<ReposeGroup[]> {
        return await lastValueFrom(
            this.http.get<ReposeGroup[]>(`${this.domain}/api/reposeGroups`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async getAllForPrint(vesselId: string): Promise<(ReposeGroup & { channel: Channel })[]> {
        return await lastValueFrom(
            this.http.get<(ReposeGroup & { channel: Channel })[]>(`${this.domain}/api/reposeGroups/print`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async create(reposeGroupData: Omit<ReposeGroup, 'id'> & Partial<Pick<ReposeGroup, 'id'>>) {
        return await lastValueFrom(
            this.http.post<OpsUser>(`${this.domain}/api/reposeGroup`, reposeGroupData, {
                headers: this.headers,
            })
        );
    }

    async update(reposeGroupData: Partial<ReposeGroup>) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/reposeGroup/${reposeGroupData.id}`, reposeGroupData, {
                headers: this.headers,
            })
        );
    }

    async delete(reposeGroupNo: string, vesselId: string) {
        return await lastValueFrom(
            this.http.delete(`${this.domain}/api/reposeGroup/${reposeGroupNo}?vesselId=${vesselId}`)
        );
    }

    async deleteList(reposeGroupNoList: string[], vesselId: string) {
        return await lastValueFrom(
            this.http.delete(`${this.domain}/api/reposeGroups`, {
                body: {
                    noList: reposeGroupNoList,
                    vesselId,
                },
            })
        );
    }

    async moveItem(groupNo: number, toGroupNo: number, vesselId: string) {
        return await lastValueFrom(
            this.http.post(`${this.domain}/api/reposeGroup/move`, {
                groupNo,
                toGroupNo,
                vesselId,
            })
        );
    }

    async saveAll(reposeGroupList: ReposeGroup[], vesselId) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/reposeGroup/upsertAll/${vesselId}`, reposeGroupList, {
                headers: this.headers,
            })
        );
    }
}
